import { OrderTypeEnum } from "@/core/enums";
import { CheckoutOrderValidationError, CheckoutOrderValidationRule } from "../enum/checkout-order-validation.enum";

export const checkoutOrderServiceAvailabilityRule: CheckoutOrderValidationRule = ({
	orderTypeName,
	serviceAvailability,
}) => {
	if (!serviceAvailability) {
		return null;
	}

	const isDelivery = orderTypeName === OrderTypeEnum.Delivery;
	const isPickup = orderTypeName === OrderTypeEnum.Pickup;
	const isServiceOpen =
		(isDelivery && serviceAvailability.delivery) ||
		(isPickup && serviceAvailability.pickup);

	return isServiceOpen ? null : CheckoutOrderValidationError.StoreClosed;
};
